<template>
  <a-icon-sheet-card
    title="Recruiting.Dashboard.OpenJobPostingsTitle"
    :count="data.count"
  >
    <div
      v-if="empty"
      v-t="'Recruiting.Dashboard.OpenJobPostingsNoJobPostings'"
      class="p-3"
    />
    <ul v-else class="list-group list-group-flush">
      <li
        v-for="(item, index) in data.jobPostings"
        :key="index"
        class="list-group-item dashboard-dashlet-list-item action-item"
        @click="itemClicked(item)"
      >
        <div class="row">
          <span class="col-12 py-0" v-text="item.name" />
          <div class="col py-0">
            <span
              v-t="'Recruiting.Dashboard.OpenJobPostingsJobApplications'"
              class="text-muted"
            />
          </div>
          <div class="col-auto py-0 text-right">
            <span
              class="font-weight-bold text-muted mr-1"
              v-text="item.countOpenJobApplications"
            />
            <span
              v-t="'Recruiting.Dashboard.OpenJobPostingsOpen'"
              class="text-muted"
            />
          </div>
          <div class="col-auto py-0 text-right">
            <span
              class="font-weight-bold text-muted mr-1"
              v-text="item.countDoneJobApplications"
            />
            <span
              v-t="'Recruiting.Dashboard.OpenJobPostingsDone'"
              class="text-muted"
            />
          </div>
        </div>
        <a-progress-bar :progress-value="getDoneJobApplicationsValue(item)" />
      </li>
    </ul>
    <template #actions>
      <a
        v-t="'Recruiting.Dashboard.ShowAll'"
        :disabled="empty"
        :class="{ 'text-muted text-decoration-none': empty }"
        href="javascript:void(0)"
        @click="goToOverview()"
      />
    </template>
  </a-icon-sheet-card>
</template>

<script>
import IconSheetCard from "+/components/card/IconSheetCard.vue";
import ProgressBar from "+/components/progressBar/ProgressBar";
import utils from "./utils/utils.js";

export default {
  components: {
    "a-icon-sheet-card": IconSheetCard,
    "a-progress-bar": ProgressBar
  },
  props: {
    data: {
      type: Object,
      default: undefined
    }
  },
  computed: {
    empty: function() {
      return this.data.count < 1;
    }
  },
  methods: {
    aggregateApplications(item) {
      return item.countOpenJobApplications + item.countDoneJobApplications;
    },
    getDoneJobApplicationsValue(item) {
      const done = item.countDoneJobApplications;
      const all = this.aggregateApplications(item);
      const onePercent = all > 0 ? 100 / all : 0;
      return done * onePercent;
    },
    itemClicked(item) {
      const route = `/main/bm.projekte.bwg?jobPostingId=${item.jobPostingId}#details`;
      this.$router.push(route);
    },
    goToOverview() {
      if (this.empty) {
        return;
      }
      utils.delZSearchSession("iBM_PROJEKTE");
      const route = `/main/bm.projekte.bwg?ERLEDIGT=1&ERLEDIGT_N=1`;
      this.$router.push(route);
    }
  }
};
</script>
